import { HiOutlineMail, HiOutlineClock } from "react-icons/hi";

export function ContactInfo() {
    return (
        <div className="rounded-3xl border border-white/[0.08] bg-white/[0.08] p-7 backdrop-blur-[6px]">
            <h3 className="mb-3 text-2xl font-semibold text-white">
                Contact info
            </h3>

            <p className="mb-10 text-white/70 text-sm">
                Choose the channel that works best.
            </p>

            <div className="space-y-8">
                <div className="flex gap-4">
                    <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-white/10 bg-white/5">
                        <HiOutlineMail className="text-xl text-web-primary" />
                    </div>

                    <div>
                        <p className="text-xs uppercase tracking-wider text-white/50">
                            Email
                        </p>
                        <p className="text-sm text-white">
                            support@empedance.com
                        </p>
                    </div>
                </div>

                <div className="flex gap-4">
                    <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-white/10 bg-white/5">
                        <HiOutlineClock className="text-xl text-web-primary" />
                    </div>

                    <div>
                        <p className="text-xs uppercase tracking-wider text-white/50">
                            Hours
                        </p>
                        <p className="text-sm text-white">
                            Mon-Fri, 9am-7pm IST
                        </p>
                    </div>
                </div>
            </div>

            <button className="mt-16 flex w-full items-center justify-center gap-2 rounded-2xl bg-web-primary py-3 text-base font-medium text-black shadow-web-glow transition hover:opacity-90">
                <img
                    src="/images/whtsappLogo.svg"
                    alt="WhatsApp"
                    className=""
                />
                <span className="text-base">Chat on WhatsApp</span>
            </button>

            <div className="my-7 border-t border-white/10" />

            <div className="space-y-2 mt-10 text-xs">
                <div className="flex justify-between text-white/70">
                    <span>Avg response</span>
                    <span>Under 2h</span>
                </div>

                <div className="flex justify-between text-white/70">
                    <span>Status</span>
                    <span className="text-web-primary">● Operational</span>
                </div>
            </div>
        </div>
    );
}